import { useCallback, useMemo } from "react";
import { useGetValueByCode } from "./useGetValueByCode";

export const useGetCreatedItems = (data: any) => {
  const { getValueByCode } = useGetValueByCode();

  const setData = useCallback(
    (map: any, code: string, label: string, prop: string, range: number) => {
      let finalCode: string = code;

      if (range === 1) {
        finalCode += "Today";
      } else if (range === 2) {
        finalCode += "ThisMonth";
      } else {
        finalCode += "ThisYear";
      }

      const val = getValueByCode(data.kpiValues, finalCode);

      if (val) {
        map[range][prop] = {
          label,
          value: val.value,
        };
      }
    },
    [data, getValueByCode],
  );

  const createdItems = useMemo(() => {
    if (data) {
      const map: any = {
        1: {},
        2: {},
        3: {},
      };

      [1, 2, 3].forEach((item: number) => {
        setData(map, "Payments.Count", "Payments", "payments", item);

        setData(
          map,
          "Disbursements.Count",
          "Disbursements",
          "disbursements",
          item,
        );

        setData(map, "Contracts.Count", "Accounts", "contracts", item);

        setData(map, "Customers.Count", "Customers", "customers", item);
      });

      return map;
    }

    return null;
  }, [data, setData]);

  return { createdItems };
};
